import Grid from '@/global/components/ui/Grid'
import { FormDatePicker } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useTrocaTabelaHorarioContext } from 'pages/TrocaTabelaHorarios.context'
import { useParams } from 'react-router-dom'
import {
    tabelaHorarios,
    trocaHorario,
    UpdateTabelaHorarioFuncionarioSchema,
} from 'service/api'
import { toast } from 'sonner'
import { encontrarTroca } from './encontrar-troca'

export default function EditarTrocaTabelaHorario() {
    const { id } = useParams<{ id: string }>()
    const { data } = useTrocaTabelaHorarioContext()
    const { mutateAsync, isLoading } =
        tabelaHorarios.funcionario.mutations.useUpdate({
            invalidateQuery: true,
        })

    const tabela = encontrarTroca(data, id)
    if (!tabela || tabela.isTrocaAutomatica) return null

    function handleSubmit(values: any) {
        return mutateAsync(
            { ...values, id: Number(id) },
            {
                onSuccess: () => {
                    toast.success('Troca atualizada com sucesso!')
                    trocaHorario.invalidateQueries()
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            open={hasPermission(['update', 'TrocaDeTabelaDeHorário'])}
            width="lg"
            onSubmit={handleSubmit}
            loading={isLoading}
            defaultValues={tabela}
            schema={UpdateTabelaHorarioFuncionarioSchema}
        >
            <Dialog.Title>
                Editar {tabela.TabelaHorario.nome?.slice(0, 40)}
            </Dialog.Title>
            <Dialog.Content>
                <Grid container>
                    <Grid item xs={12} sm={5}>
                        <FormDatePicker
                            label="Data inicial"
                            name="dtInicial"
                            type="date"
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormDatePicker
                            label="Data final"
                            name="dtFinal"
                            type="date"
                            helperText="Deixe em branco para indeterminado"
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
